import Logo from 'Pages/LoginPage/Logo'
import React from 'react'

const AuthWrapper = ({ heading, subheading, children }) => {
    return (
        <div className="relative min-h-screen flex items-center justify-center p-4 bg-[#f0f2f6]">
            {/* Main container */}
            <div className="relative w-full max-w-2xl">

                <div className="relative p-12 bg-white shadow-2xl rounded-3xl">
                    {/* Logo and header */}
                    <div className="flex flex-col items-center space-y-6">
                        <Logo className="w-16" src="/trucare-favicon.png" />
                        <div className="text-center">
                            <h1 className="text-2xl font-bold text-gray-900">{heading}</h1>
                            <p className="mt-3 text-gray-600">
                                {subheading}
                            </p>
                        </div>
                    </div>
                    {children}
                </div>

                {/* Powered by TruCare - Outside the card */}
                <div className="mt-6 text-center">
                    <p className="text-sm text-gray-500">Powered by TruCare.</p>
                </div>
            </div>
        </div>
    )
}

export default AuthWrapper